'use client';

import { FC } from 'react';
import styles from './AuthFormBack.module.scss';
import { useFormStepTransition } from 'src/general/transitions/FormStepTransition/FormStepTransition.context';
import { ButtonIcon } from 'src/general/components/Button/ButtonIcon';
import { IconArrowLeft } from 'src/general/Icons/IconArrowLeft';
import { Button } from 'src/general/components/Button/Button';
import { shallow } from 'zustand/shallow';
import clsx from 'clsx';
import { stepFormStore } from 'src/steps-form/stepFormStore';

type Props = {
  className?: string;
};

export const AuthFormBack: FC<Props> = ({ className }) => {
  const { onBack } = stepFormStore(
    (state) => ({
      onBack: state.onBack,
    }),
    shallow,
  );
  const { navigate } = useFormStepTransition();
  const clickBack = onBack
    ? () => {
        typeof onBack === 'function' ? onBack() : navigate(onBack, true);
      }
    : undefined;

  if (!onBack) return null;

  return (
    <div className={clsx(styles.root, className)}>
      <ButtonIcon
        Icon={IconArrowLeft}
        onClick={clickBack}
        title="Back"
        variant="tertiary"
        size="small"
        className={styles.backMobile}
        data-testid="AuthFormHeader-component-backIcon"
      />
      <Button
        startIcon={<IconArrowLeft />}
        onClick={clickBack}
        variant="tertiary"
        className={styles.backDesktop}
        data-testid="AuthFormHeader-component-backButton"
      >
        Back
      </Button>
    </div>
  );
};
